import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';

export default class UsernameHistoryPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }

  content() {
    const user = this.user;

    if (!user) {
      return (
        <div className="UsernameHistoryPage">
          <div className="UsernameHistoryPage-empty">
            <i className="fas fa-spinner fa-spin" />
          </div>
        </div>
      );
    }

    const history = user.attribute('usernameHistory') || [];

    if (history.length === 0) {
      return (
        <div className="UsernameHistoryPage">
          <div className="UsernameHistoryPage-empty">
            <i className="fas fa-user-clock" />
            <p>{app.translator.trans('happydigital-username-history.forum.no_history')}</p>
          </div>
        </div>
      );
    }

    const isOwnProfile = app.session.user && app.session.user.id() === user.id();
    const canChange = user.attribute('canChangeUsername');

    return (
      <div className="UsernameHistoryPage">
        {isOwnProfile && canChange && (
          <div className="UsernameHistoryPage-actions">
            <button
              className="Button Button--primary"
              onclick={() => app.modal.show(require('./ChangeUsernameModal').default)}
            >
              <i className="fas fa-user-edit Button-icon" />
              {app.translator.trans('happydigital-username-history.forum.change_username_button')}
            </button>
          </div>
        )}

        <ul className="UsernameHistoryPage-list">
          {history.map((item, idx) => (
            <li key={idx} className="UsernameHistoryPage-item">
              <span className="UsernameHistoryPage-index">#{idx + 1}</span>
              <span className="UsernameHistoryPage-username">
                <i className="fas fa-at" />
                {item.username}
              </span>
              <span className="UsernameHistoryPage-date">
                <i className="fas fa-calendar-alt" />
                {this.formatDate(item.changedAt)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  formatDate(isoString) {
    if (!isoString) return '';
    try {
      return new Date(isoString).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (e) {
      return isoString;
    }
  }
}
